import { render, staticRenderFns } from "./projectOrderDet.vue?vue&type=template&id=0e2d9f3e&scoped=true"
import script from "./projectOrderDet.vue?vue&type=script&lang=js"
export * from "./projectOrderDet.vue?vue&type=script&lang=js"
import style0 from "./projectOrderDet.vue?vue&type=style&index=0&id=0e2d9f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d9f3e",
  null
  
)

export default component.exports